import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { Claim, EASE, GoldRule, MaskedLine, Micro, Reveal, SlideShell } from "../shared";
import { IMG } from "../images";

export default function Slide01Cover() {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const sx = useSpring(mx, { stiffness: 45, damping: 22, mass: 0.6 });
  const sy = useSpring(my, { stiffness: 45, damping: 22, mass: 0.6 });
  const x = useTransform(sx, [-0.5, 0.5], [-16, 16]);
  const y = useTransform(sy, [-0.5, 0.5], [-12, 12]);

  const handleMouse = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };

  return (
    <SlideShell theme="navy" testid="slide-1-cover" onMouseMove={handleMouse}>
      <motion.div className="absolute inset-[-3%]" style={{ x, y }}>
        <motion.img
          src={IMG.cover}
          alt="Costiera Amalfitana al tramonto"
          className="h-full w-full object-cover"
          initial={{ scale: 1.16, opacity: 0.5 }}
          animate={{ scale: 1.05, opacity: 1 }}
          transition={{ duration: 2.6, ease: EASE }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#060B19] via-[#060B19]/45 to-[#060B19]/30" />
      </motion.div>

      <div className="relative z-10 flex h-full flex-col justify-end px-6 pb-32 sm:px-12 lg:px-20">
        <Reveal delay={0.5}>
          <Micro>Costiera Amalfitana · Investor Deck · 2026</Micro>
        </Reveal>
        <h1 className="mt-6 font-serif text-[12vw] font-medium leading-[0.98] tracking-tight text-[#FAF7F2] sm:text-6xl lg:text-7xl xl:text-[84px]">
          <MaskedLine delay={0.65}>IL NUOVO STANDARD</MaskedLine>
          <MaskedLine delay={0.78}>
            PER LA <em className="italic text-[#D4AF37]">LUXURY VILLA</em>
          </MaskedLine>
          <MaskedLine delay={0.91}>HOSPITALITY</MaskedLine>
        </h1>
        <Reveal delay={1.2} className="mt-9 flex items-center gap-5">
          <GoldRule delay={1.2} />
          <Claim>5-Star Hospitality. Private Villa Living.</Claim>
        </Reveal>
      </div>

      <div className="absolute bottom-8 right-8 z-10 hidden flex-col items-center gap-2 lg:flex">
        <span className="font-mono text-[10px] tracking-[0.35em] text-white/50 [writing-mode:vertical-rl]">
          SCORRI
        </span>
        <motion.span animate={{ y: [0, 6, 0] }} transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}>
          <ChevronDown size={14} className="text-[#D4AF37]" />
        </motion.span>
      </div>
    </SlideShell>
  );
}
